import { render } from "./main-page-login.vue?vue&type=template&id=2e883968&scoped=true"
import script from "./main-page-login.vue?vue&type=script&lang=js"
export * from "./main-page-login.vue?vue&type=script&lang=js"

import "./main-page-login.vue?vue&type=style&index=0&id=2e883968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e883968"]])

export default __exports__